import { render, staticRenderFns } from "./SatisfactoryPerformance.vue?vue&type=template&id=3c947a3b"
import script from "./SatisfactoryPerformance.vue?vue&type=script&lang=js"
export * from "./SatisfactoryPerformance.vue?vue&type=script&lang=js"
import style0 from "./SatisfactoryPerformance.vue?vue&type=style&index=0&id=3c947a3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports